module.exports = __webpack_public_path__ + "img/slider-img2.70a4d28e.png";